import { render } from "./App.vue?vue&type=template&id=aa5b2148"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=aa5b2148&lang=css"

import exportComponent from "D:\\webprojects\\220914order-buy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__